<template>
  <!-- 定制支付页面 -->
  <myhead @next="next">{{ $route.query.title || $route.meta.title }}</myhead>
  <div style="padding-bottom: 100px">
    <div class="complete" >
      <div class="complete-tle flex">
        <img :src="goodsinfo.head_pic" :onerror="Imgerror" />
        <p class="size14">{{ goodsinfo.goods_name }}</p>
      </div>
      <div class=" complete-name mb20">
        <img :src="goodsinfo.original_img" :onerror="Imgerror" />
        <div class="complete-list size14">
          {{ goodsinfo.goods_name }}
        </div>
      </div>
      <div style="margin-top: 5.3333vw;">
        <p class="a345 size15">合同上传</p>
        <div class="uploader-box">
          <van-uploader  v-model="fileList" multiple />
        </div>
      </div>
      <div class="graybar"></div>
      <div class="remake flex between">
        <p>备注</p>
        <div class="remake-textarea">
          <van-field v-model="user_note" placeholder="建议备注前先与卖家达成一致" input-align="right" type="textarea" />
        </div>
      </div>
    </div>
  </div>
  <div class="tabbar flex">
     <p class="money">待卖家评定</p>
     <div class="tabbar-btn" @click="handleSubmit">
         <p>提交</p>
     </div>
   </div>
   <van-dialog v-model:show="show" title="提交完成" confirm-button-text="查看订单" cancel-button-text="返回" @confirm="$router.push('/shop/order')" @cancel="$router.go(-1)" show-cancel-button>
</van-dialog>
</template>
<script>
import ajax from "@/utils/request.js";
import { showToast } from "vant";
export default {
  data () {
    return {
      fileList: [],
      goodsinfo: {},
      user_note:'',
      show:false
    };
  },
  created(){
    this.init()
  },
  methods:{
    init(){
      ajax
      .post("order/getcustominfo", { goods_id : this.$route.query.goods_id})
      .then(res=>{
        this.goodsinfo = res.data
      })
               
    },
    handleSubmit () {
      if(this.fileList.length==0){
       return showToast('请上传合同信息');
      }
      const data = {
        goods_id : this.$route.query.goods_id,
        user_note: this.user_note,
        contract_imgs: [] // 用于存储图片链接的数组
      };

        const uploadPromises = this.fileList.map((item) => {
          return ajax.post("api/dyuploadimg", { file: item.file })
            .then((res) => {
              data.contract_imgs.push(res.data.url);
            });
        });

        // 使用 Promise.all 等待所有图片上传操作完成
        Promise.all(uploadPromises)
          .then(() => {
            ajax.post("order/customsubmit", data)
              .then((res) => {
                if(res.errcode == 1){
                  this.show  = true
                }
              });
          })
          .catch((error) => {
            console.error("图片上传失败:", error);
            // 处理图片上传失败的情况
          });
    }
  }
};
</script>
<style scoped lang="scss">
.uploader-box {
    margin-top: 2.6667vw;
}
.tabbar {
    position: fixed;
    height: 17.0667vw;
    padding: 0 4vw;
    bottom: 0;
    left: 0;
    right: 0;
    background: #FFFFFF;
    box-shadow: 0px -1px 20px 0px rgba(0,0,0,0.08);
    justify-content: flex-end;
}
.money {
    margin-right: 5.3333vw;
    color: #e30000;
    font-size: 14px;
}
.tabbar-btn {
    width: 23.2vw;
    height: 10.6667vw;
    line-height: 10.6667vw;
    background: #E30000;
    border-radius: 5.6vw;
    color: #ffffff;
    font-size: 14px;
    text-align: center;
    letter-spacing: 1px;
}

.complete {
  padding: 4vw;
  border-radius: 10px;
  background-color: #fff;
}
.complete-tle img {
  width: 4.8vw;
  height: 4.8vw;
  border-radius: 10%;
  object-fit: contain;
  margin-right: 1.0667vw;
}
.complete-tle p {
  color: #333333;
}
.complete-name {
  display: flex;
  align-items: center;
  margin-top: 2.6667vw;
  img {
    width: 26.6667vw;
    height: 26.6667vw;
    background: #ffffff;
    border-radius: 1.0667vw;
  }
  .complete-list {
    // width: 56.2667vw;
    flex: 1;
    margin-left: 2.6667vw;
    text-align: left;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    -o-text-overflow: ellipsis;
  }
}

.graybar {
  width: 100%;
  margin: 0 auto;
  border-bottom: 1px solid #cccccc;
}
.remake {
  align-items: flex-start;
  padding: 2.6667vw 0;
  background-color: #fff;
}
.remake .van-cell {
  padding: 0;
}
.remake-textarea {
  width: 59.7333vw;
}



</style>
